import { storeFactory } from '@ovpn-ui/utils';
const sidebarStoredState = storeFactory('sidebar', '@ovpn');
export function getSidebarStateStorage() {
  return {
    getState: () => sidebarStoredState.get() !== 'false',
    setState: value => {
      sidebarStoredState.set(value.toString());
    }
  };
}
export function getIsSidebarOpen() {
  return getSidebarStateStorage().getState();
}